import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import requester from "../../lib/requester";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import moment from "moment";
import _ from "lodash";
import ReactExport from "react-export-excel-hot-fix";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { faAlignRight } from "@fortawesome/free-solid-svg-icons";
import { text } from "@fortawesome/fontawesome-svg-core";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      dataTable: [],
      baseTable: [],
      search: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
      fromDate: "",
      toDate: "",
      submittedDateFrom: "",
      submittedDateTo: "",
      setStatus: "",
      setBranch: "",
      setPrincipal: "",
      lovPrincipal: [],
      princid: "",
      lovBranch: [],
      export: false,
      originOrgid: "",
    };
  }

  componentDidMount = () => {
    // let url = '/api/traces/v1/report/reportprincipal'
    // let param = {
    //     org_id: this.state.user.org_id,
    //     source: 'arman'
    // }
    // this.setState({ loading: true })
    // requester.postTraces(url, param, {
    //     success: function (response) {
    //         let { data } = response.data
    //         data.data.map((item, index) => {
    //             item.formatted_start_date = moment(item.start_date).format('DD-MM-YYYY')
    //             item.formatted_end_date = moment(item.end_date).format('DD-MM-YYYY')
    //             return item
    //         })
    //         this.setState({ loading: false, dataTable: data.data, baseTable: data.data })
    //     }.bind(this),
    //     error: function (e) {
    //         this.setState({ loading: false })
    //     }.bind(this)
    // })
    this.getPrincipal();
    this.getBranch();
  };

  getBranch = () => {
    // let branchGroup = this.state.user.branch.map((item, index) => {
    //     return item.org_id
    // })

    let url = "/api/traces/v1/general/list-cabang";
    requester.getTraces(url, {
      success: function (response) {
        this.setState({ lovBranch: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });

    if (this.state.user.origin === "CAB") {
      this.state.originOrgid = this.state.user.org_id;
      this.state.setBranch = this.state.user.org_id;
    }

    // this.setState({ lovBranch: this.state.user.branch });
    console.log(this.state.originOrgid);
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "BRANCH",
          accessor: "BRANCH",
          filterable: true,
          width: 200,
        },
        {
          Header: "SUBMIT_DATE_CLAIM",
          accessor: "SUBMIT_DATE_CLAIM",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },

        {
          Header: "PRINCIPAL_CODE",
          accessor: "PRINCIPAL_CODE",
          filterable: true,
          width: 200,
        },
        {
          Header: "AWB_NO_HO",
          accessor: "AWB_NO_HO",
          filterable: true,
          width: 200,
        },
        {
          Header: "LT_CAB_HO", // BARU
          accessor: "LT_CAB_HO",
          filterable: true,
          width: 200,
          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "AWB_RECEIPT_DATE_PRINCIPAL",
          accessor: "AWB_RECEIPT_DATE_PRINCIPAL",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "PRINCIPAL_CLAIM_RECEIPT_DATE",
          accessor: "PRINCIPAL_CLAIM_RECEIPT_DATE",
          filterable: true,
          width: 200,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "LT_HO_PRINCIPAL", // BARU
          accessor: "LT_HO_PRINCIPAL",
          filterable: true,
          width: 200,
          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "PAYMENT_METHOD",
          accessor: "PAYMENT_METHOD",
          filterable: true,
          width: 200,
        },
        {
          Header: "KWITANSI",
          accessor: "KWITANSI",
          filterable: true,
          width: 200,
        },
        {
          Header: "CLAIM_NUMBER",
          accessor: "CLAIM_NUMBER",
          filterable: true,
          width: 200,
        },
        {
          Header: "STATUS",
          accessor: "STATUS",
          filterable: true,
          width: 200,
        },
        {
          Header: "APPROVED_REJECTED_DATE",
          accessor: "APPROVED_REJECTED_DATE",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "REASON_REJECTED",
          accessor: "REASON_REJECTED",
          filterable: true,
          width: 200,
        },
        {
          Header: "LT_APPROVAL_PRINCIPAL", // BARU
          accessor: "LT_APPROVAL_PRINCIPAL",
          filterable: true,
          width: 200,
          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "CUST_INVOICE_NO", //BARU
          accessor: "CUST_INVOICE_NO",
          filterable: true,
          width: 200,
        },
        {
          Header: "PRINCIPAL_CLAIM_ID",
          accessor: "PRINCIPAL_CLAIM_ID",
          filterable: true,
        },
        {
          Header: "PRINCIPAL STATUS",
          accessor: "PRINCIPAL_STATUS",
          filterable: true,
          width: 200,
        },
        {
          Header: "CUSTOMER_GROUP",
          accessor: "CUSTOMER_GROUP",
          filterable: true,
          width: 200,
        },
        {
          Header: "CUSTOMER_NAME",
          accessor: "CUSTOMER_NAME",
          filterable: true,
          width: 200,
        },
        {
          Header: "PROGRAM_TYPE",
          accessor: "PROGRAM_TYPE",
          filterable: true,
          width: 200,
        },
        {
          Header: "PROGRAM_DESCRIPTIONS",
          accessor: "PROGRAM_DESCRIPTIONS",
          filterable: true,
          width: 200,
        },
        {
          Header: "REF_NUMBER/SKP",
          accessor: "REF_NUMBER",
          filterable: true,
          width: 200,
        },
        {
          Header: "TRACES_NUMBER",
          accessor: "TRACES_NUMBER",
          filterable: true,
          width: 200,
        },
        {
          Header: "START_DATE_PROGRAM",
          accessor: "START_DATE_PROGRAM",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "END_DATE_PROGRAM",
          accessor: "END_DATE_PROGRAM",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "CLAIM_EXP_DATE",
          accessor: "CLAIM_EXP_DATE",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },

        {
          Header: "NILAI_DPP",
          accessor: "NILAI_DPP",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "NILAI_PPN",
          accessor: "NILAI_PPN",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "TOTAL_CLAIM",
          accessor: "TOTAL_CLAIM",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },

        {
          Header: "PPH_TYPE",
          accessor: "PPH_TYPE",
          filterable: true,
          width: 200,
        },
        {
          Header: "PPH_RATE",
          accessor: "PPH_RATE",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "NILAI_PPH",
          accessor: "NILAI_PPH",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "CLAIM_NET",
          accessor: "CLAIM_NET",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },

        {
          Header: "NO_NPWP_RELASI",
          accessor: "NO_NPWP_RELASI",
          filterable: true,
          width: 200,
        },
        {
          Header: "NAMA_NPWP_RELASI",
          accessor: "NAMA_NPWP_RELASI",
          filterable: true,
          width: 200,
        },
        {
          Header: "ALAMAT_NPWP_RELASI",
          accessor: "ALAMAT_NPWP_RELASI",
          filterable: true,
          width: 200,
        },
        {
          Header: "TAX_NO",
          accessor: "TAX_NO",
          filterable: true,
          width: 200,
        },
        {
          Header: "TAX_DATE",
          accessor: "TAX_DATE",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "SKB_NUMBER",
          accessor: "SKB_NUMBER",
          filterable: true,
          width: 200,
        },
        {
          Header: "COVER_LETTER_NUMBER",
          accessor: "COVER_LETTER_NUMBER",
          filterable: true,
          width: 200,
        },
        {
          Header: "COVER_LETTER_DATE",
          accessor: "COVER_LETTER_DATE",
          filterable: true,
          width: 200,
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          filterable: true,
        },

        {
          Header: "ACCOUNT_NO",
          accessor: "ACCOUNT_NO",
          filterable: true,
          width: 200,
        },
        {
          Header: "ACCOUNT_NAME",
          accessor: "ACCOUNT_NAME",
          filterable: true,
          width: 200,
        },
        {
          Header: "BANK_ACCOUNT",
          accessor: "BANK_ACCOUNT",
          filterable: true,
          width: 200,
        },
        {
          Header: "PAYMENT_AMOUNT",
          accessor: "PAYMENT_AMOUNT",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "PAYMENT_DATE",
          accessor: "PAYMENT_DATE",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },
        {
          Header: "NO_EBUPOT",
          accessor: "NO_EBUKPOT",
          filterable: true,
          width: 200,
        },
        {
          Header: "NILAI_EBUPOT",
          accessor: "NILAI_EBUKPOT",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? row.value.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                  : ""}
              </span>
            </div>
          ),
        },
        {
          Header: "TGL_FISIK_BUPOT",
          accessor: "TGL_FISIK_BUKPOT",
          filterable: true,
          width: 200,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          // ,filterable: true
        },

        // {
        //   Header: "PRINCIPAL_CLAIM_ID",
        //   accessor: "PRINCIPAL_CLAIM_ID",
        //   filterable: true, width: 200,
        // },

        // {
        //   Header: "NOTES PARTICIPANTS",
        //   accessor: "NOTES",
        //   filterable: true, width: 200,
        // },
        {
          Header: "PRINCIPAL_NOTES",
          accessor: "NOTES",
          filterable: true,
          width: 200,
        },
        //==============================================================
        //==============================================================
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = row[filter.id];
          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  exportToExcel = () => {
    const dataSet2 = this.state.dataTable;
    let filename =
      "traces-principal-" + moment(new Date()).format("DDMMYYYYHHmmss");

    return (
      <ExcelFile
        filename={filename}
        fileExtension="xlsx"
        element={
          <button className="btn btn-success btn-block">
            <i className="fas fa-file-excel" /> Export To Excel
          </button>
        }
      >
        <ExcelSheet data={dataSet2} name="Leaves">
          <ExcelColumn label="AWB_NO_HO" value="AWB_NO_HO" />
          <ExcelColumn
            label="AWB_RECEIPT_DATE_PRINCIPAL"
            value="AWB_RECEIPT_DATE_PRINCIPAL"
          />
          <ExcelColumn
            label="PRINCIPAL_CLAIM_RECEIPT_DATE"
            value="PRINCIPAL_CLAIM_RECEIPT_DATE"
          />
          <ExcelColumn label="BRANCH" value="BRANCH" />
          <ExcelColumn label="CLAIM_NUMBER" value="CLAIM_NUMBER" />
          <ExcelColumn label="STATUS" value="STATUS" />
          <ExcelColumn label="PRINCIPAL_CLAIM_ID" value="PRINCIPAL_CLAIM_ID" />
          <ExcelColumn label="PRINCIPAL_STATUS" value="PRINCIPAL_STATUS" />
          <ExcelColumn label="CUSTOMER_NAME" value="CUSTOMER_NAME" />
          <ExcelColumn label="PROGRAM_TYPE" value="PROGRAM_TYPE" />
          <ExcelColumn
            label="PROGRAM_DESCRIPTIONS"
            value="PROGRAM_DESCRIPTIONS"
          />
          <ExcelColumn label="REF_NUMBER" value="REF_NUMBER" />
          <ExcelColumn label="TRACES_NUMBER" value="TRACES_NUMBER" />
          <ExcelColumn label="PRINCIPAL_CODE" value="PRINCIPAL_CODE" />
          <ExcelColumn label="PRINCIPAL_NOTES" value="NOTES" />
          <ExcelColumn label="START_DATE_PROGRAM" value="START_DATE_PROGRAM" />
          <ExcelColumn label="END_DATE_PROGRAM" value="END_DATE_PROGRAM" />
          <ExcelColumn label="SUBMIT_DATE_CLAIM" value="SUBMIT_DATE_CLAIM" />
          <ExcelColumn
            label="APPROVED_REJECTED_DATE"
            value="APPROVED_REJECTED_DATE"
          />
          <ExcelColumn label="REASON_REJECTED" value="REASON_REJECTED" />
          <ExcelColumn label="NILAI_DPP" value="NILAI_DPP" />
          <ExcelColumn label="NILAI_PPN" value="NILAI_PPN" />
          <ExcelColumn label="TOTAL_CLAIM" value="TOTAL_CLAIM" />
          <ExcelColumn label="PPH_TYPE" value="PPH_TYPE" />
          <ExcelColumn label="PPH_RATE" value="PPH_RATE" />
          <ExcelColumn label="NILAI_PPH" value="NILAI_PPH" />
          <ExcelColumn label="CLAIM_NET" value="CLAIM_NET" />
          <ExcelColumn label="PAYMENT_METHOD" value="PAYMENT_METHOD" />
          <ExcelColumn label="NO_NPWP_RELASI" value="NO_NPWP_RELASI" />
          <ExcelColumn label="NAMA_NPWP_RELASI" value="NAMA_NPWP_RELASI" />
          <ExcelColumn label="ALAMAT_NPWP_RELASI" value="ALAMAT_NPWP_RELASI" />
          <ExcelColumn label="TAX_NO" value="TAX_NO" />
          <ExcelColumn label="TAX_DATE" value="TAX_DATE" />
          <ExcelColumn label="SKB_NUMBER" value="SKB_NUMBER" />
          <ExcelColumn
            label="COVER_LETTER_NUMBER"
            value="COVER_LETTER_NUMBER"
          />
          <ExcelColumn label="COVER_LETTER_DATE" value="COVER_LETTER_DATE" />
          <ExcelColumn label="ACCOUNT_NO" value="ACCOUNT_NO" />
          <ExcelColumn label="ACCOUNT_NAME" value="ACCOUNT_NAME" />
          <ExcelColumn label="BANK_ACCOUNT" value="BANK_ACCOUNT" />
          <ExcelColumn label="PAYMENT_AMOUNT" value="PAID_AMOUNT" />
          <ExcelColumn label="PAYMENT_DATE" value="PAYMENT_DATE" />
          <ExcelColumn
            label="UPLOAD_DATE_EBUPOT"
            value="UPLOAD_DATE_EBUKPOT"
          />
          <ExcelColumn label="NO_EBUPOT" value="NO_EBUKPOT" />
          <ExcelColumn label="NILAI_EBUPOT" value="NILAI_EBUKPOT" />
          <ExcelColumn label="TGL_FISIK_BUKPOT" value="TGL_FISIK_BUKPOT" />
        </ExcelSheet>
      </ExcelFile>
    );
  };

  getPrincipal = () => {
    let url = "/api/traces/v1/general/list-principal";
    requester.getTraces(url, {
      success: function (response) {
        this.setState({ lovPrincipal: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  goDetail = (rows) => {
    let { row } = rows;
    this.props.history.push("/admin/assign/summary/" + row.program_customer_id);
  };

  handleSearch = () => {
    let url = "/api/traces/v1/report/reportprincipal";
    let param = {
      export: this.state.export,
      org_id: this.state.setBranch,
      source: "arman",
      status: this.state.setStatus,
      active_status: this.state.activeStatus,
      principal: this.state.setPrincipal,
      from_date:
        this.state.fromDate != ""
          ? moment(new Date(this.state.fromDate)).format("YYYY-MM-DD")
          : "",
      to_date:
        this.state.toDate != ""
          ? moment(new Date(this.state.toDate)).format("YYYY-MM-DD")
          : "",
      submit_from:
        this.state.submittedDateFrom != ""
          ? moment(new Date(this.state.submittedDateFrom)).format("YYYY-MM-DD")
          : "",
      submit_to:
        this.state.submittedDateTo != ""
          ? moment(new Date(this.state.submittedDateTo)).format("YYYY-MM-DD")
          : "",
    };

    this.setState({ loading: true });
    requester.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        data.data.map((item, index) => {
          item.formatted_start_date = moment(new Date(item.start_date)).format(
            "DD-MM-YYYY"
          );
          item.formatted_end_date = moment(new Date(item.end_date)).format(
            "DD-MM-YYYY"
          );
          return item;
        });

        if (this.state.export) {
          window.open(data.fullurl, "_blank");
        }
        this.setState({
          loading: false,
          dataTable: data.data,
          baseTable: data.data,
          export: false,
        });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
    // this.getPrincipal();
    // this.getBranch();
  };

  handleChangeStatus = (e) => {
    this.state.setStatus = e.target.value;
  };

  handleChangeBranch = (e) => {
    this.state.setBranch = e.target.value;
  };

  handleChangePrincipal = (e) => {
    this.state.setPrincipal = e.target.value;
  };

  handleChangeValue = (event) => {
    let value = event.target.value;
    let valname = event.target.name;

    // this.setState({ activeflag: value })

    if (valname === "org_id") {
      this.setState({ princid: value });
    }

    window.setTimeout(() => {
      console.log(valname);
    }, 100);
  };

  handleFind = () => {
    let url = "/api/traces/v1/report/reportprincipal";
    let param = {
      org_id: this.state.user.org_id,
      source: "arman",
      from_date: moment(this.state.fromDate).format("YYYY-MM-DD"),
      to_date: moment(this.state.toDate).format("YYYY-MM-DD"),
    };

    this.setState({ loading: true, search: "" });
    requester.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        data.map((item, index) => {
          item.formatted_start_date = moment(item.start_date).format(
            "DD-MM-YYYY"
          );
          item.formatted_end_date = moment(item.end_date).format("DD-MM-YYYY");
          return item;
        });
        this.setState({ loading: false, dataTable: data, baseTable: data });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  badgeClass = (status) => {
    let className = "";
    if (status === "P") {
      className = "badge badge-info";
    } else if (status === "A") {
      className = "badge badge-success";
    } else if (status === "R") {
      className = "badge badge-danger";
    } else if (status === "S") {
      className = "badge badge-secondary";
    }
    console.log(className);
    return className;
  };

  mappingStatus = (status) => {
    let mappingStatus = "";
    if (status === "P") {
      mappingStatus = "PROPOSE";
    } else if (status === "A") {
      mappingStatus = "APPROVED";
    } else if (status === "R") {
      mappingStatus = "REJECT";
    } else if (status === "S") {
      mappingStatus = "ASSIGN";
    }
    console.log(mappingStatus);
    return mappingStatus;
  };

  handlefromDate = (date) => {
    this.setState({ fromDate: date });
  };

  handletoDate = (date) => {
    this.setState({ toDate: date });
  };

  handleSubmittedDateFrom = (date) => {
    this.setState({ submittedDateFrom: date });
  };

  handleSubmittedDateTo = (date) => {
    this.setState({ submittedDateTo: date });
  };

  handleExport = () => {
    const fileName = `traces-principal-${new Date().getTime()}.xlsx`
    const maping = this.state.dataTable && this.state.dataTable.length ? this.state.dataTable.map((value) => {
      return {
        "BRANCH": value.BRANCH,
        "SUBMIT_DATE_CLAIM": value.SUBMIT_DATE_CLAIM && value.SUBMIT_DATE_CLAIM !== "0000-00-00" ? new Date(moment(value.SUBMIT_DATE_CLAIM).utc().format("DD MMM YYYY")) : '-',
        "PRINCIPAL_CODE": value.PRINCIPAL_CODE,
        "AWB_NO_HO": value.AWB_NO_HO,
        "LT_CAB_HO": value.LT_CAB_HO,
        "AWB_RECEIPT_DATE_PRINCIPAL": value.AWB_RECEIPT_DATE_PRINCIPAL && value.AWB_RECEIPT_DATE_PRINCIPAL !== "0000-00-00" ? new Date(moment(value.AWB_RECEIPT_DATE_PRINCIPAL).utc().format("DD MMM YYYY")) : '-',
        "PRINCIPAL_CLAIM_RECEIPT_DATE": value.PRINCIPAL_CLAIM_RECEIPT_DATE && value.PRINCIPAL_CLAIM_RECEIPT_DATE !== "0000-00-00" ? new Date(moment(value.PRINCIPAL_CLAIM_RECEIPT_DATE).utc().format("DD MMM YYYY")) : '-',
        "LT_HO_PRINCIPAL": value.LT_HO_PRINCIPAL,
        "PAYMENT_METHOD": value.PAYMENT_METHOD,
        "KWITANSI": value.KWITANSI,
        "CLAIM_NUMBER": value.CLAIM_NUMBER,
        "STATUS": value.STATUS,
        "APPROVED_REJECTED_DATE": value.APPROVED_REJECTED_DATE && value.APPROVED_REJECTED_DATE !== "0000-00-00" ? new Date(moment(value.APPROVED_REJECTED_DATE).utc().format("DD MMM YYYY")) : '-',
        "REASON_REJECTED": value.REASON_REJECTED,
        "LT_APPROVAL_PRINCIPAL": value.LT_APPROVAL_PRINCIPAL,
        "CUST_INVOICE_NO": value.CUST_INVOICE_NO,
        "PRINCIPAL_CLAIM_ID": value.PRINCIPAL_CLAIM_ID,
        "PRINCIPAL STATUS": value.PRINCIPAL_STATUS,
        "CUSTOMER_GROUP": value.CUSTOMER_GROUP,
        "CUSTOMER_NAME": value.CUSTOMER_NAME,
        "PROGRAM_TYPE": value.PROGRAM_TYPE,
        "PROGRAM_DESCRIPTIONS": value.PROGRAM_DESCRIPTIONS,
        "REF_NUMBER/SKP": value.REF_NUMBER,
        "TRACES_NUMBER": value.TRACES_NUMBER,
        "START_DATE_PROGRAM": value.START_DATE_PROGRAM && value.START_DATE_PROGRAM !== "0000-00-00" ? new Date(moment(value.START_DATE_PROGRAM).utc().format("DD MMM YYYY")) : '-',
        "END_DATE_PROGRAM": value.END_DATE_PROGRAM && value.END_DATE_PROGRAM !== "0000-00-00" ? new Date(moment(value.END_DATE_PROGRAM).utc().format("DD MMM YYYY")) : '-',
        "CLAIM_EXP_DATE": value.CLAIM_EXP_DATE && value.CLAIM_EXP_DATE !== "0000-00-00" ? new Date(moment(value.CLAIM_EXP_DATE).utc().format("DD MMM YYYY")) : '-',
        "NILAI_DPP": value.NILAI_DPP,
        "NILAI_PPN": value.NILAI_PPN,
        "TOTAL_CLAIM": value.TOTAL_CLAIM,
        "PPH_TYPE": value.PPH_TYPE,
        "PPH_RATE": value.PPH_RATE,
        "NILAI_PPH": value.NILAI_PPH,
        "CLAIM_NET": value.CLAIM_NET,
        "NO_NPWP_RELASI": value.NO_NPWP_RELASI,
        "NAMA_NPWP_RELASI": value.NAMA_NPWP_RELASI,
        "ALAMAT_NPWP_RELASI": value.ALAMAT_NPWP_RELASI,
        "TAX_NO": value.TAX_NO,
        "TAX_DATE": value.TAX_DATE && value.TAX_DATE !== "0000-00-00" ? new Date(moment(value.TAX_DATE).utc().format("DD MMM YYYY")) : '-',
        "SKB_NUMBER": value.SKB_NUMBER,
        "COVER_LETTER_NUMBER": value.COVER_LETTER_NUMBER,
        "COVER_LETTER_DATE": value.COVER_LETTER_DATE && value.COVER_LETTER_DATE !== "0000-00-00" ? new Date(moment(value.COVER_LETTER_DATE).utc().format("DD MMM YYYY")) : '-',
        "ACCOUNT_NO": value.ACCOUNT_NO,
        "ACCOUNT_NAME": value.ACCOUNT_NAME,
        "BANK_ACCOUNT": value.BANK_ACCOUNT,
        "PAYMENT_AMOUNT": value.PAYMENT_AMOUNT,
        "PAYMENT_DATE": value.PAYMENT_DATE && value.PAYMENT_DATE !== "0000-00-00" ? new Date(moment(value.PAYMENT_DATE).utc().format("DD MMM YYYY")) : '-',
        "NO_EBUPOT": value.NO_EBUKPOT,
        "NILAI_EBUPOT": value.NILAI_EBUKPOT,
        "TGL_FISIK_BUPOT": value.TGL_FISIK_BUKPOT && value.TGL_FISIK_BUKPOT !== "0000-00-00" ? new Date(moment(value.TGL_FISIK_BUKPOT).utc().format("DD MMM YYYY")) : '-',
        "PRINCIPAL_NOTES": value.NOTES,
      }
    }) : []

    requester.downloadXlsxDateFormat(maping, fileName)
    // this.setState({ export: true });
    // let app = this;
    // window.setTimeout(() => {
    //   app.handleSearch();
    // }, 300);
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-body">
                            <div className="row mt-3">
                              <div className="col-md-2">Branch</div>
                              <div className="col-md-3">
                                <select
                                  className="form-control"
                                  name="branchId"
                                  onChange={this.handleChangeBranch.bind(this)}
                                >
                                  <option value="">ALL</option>
                                  {this.state.lovBranch.map((item, index) => (
                                    <option
                                      value={item.org_id}
                                      key={index}
                                      selected={
                                        this.state.originOrgid == item.org_id
                                          ? true
                                          : false
                                      }
                                    >
                                      {item.org_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-md-2">Principal</div>
                              <div className="col-md-3">
                                <select
                                  className="form-control"
                                  name="org_id"
                                  onChange={this.handleChangePrincipal.bind(
                                    this
                                  )}
                                >
                                  <option value="">ALL</option>
                                  {this.state.lovPrincipal.map(
                                    (item, index) => (
                                      <option value={item.org_id}>
                                        {item.org_name}
                                      </option>
                                    )
                                  )}
                                </select>
                              </div>
                            </div>
                            <div className="clearfix">&nbsp;</div>
                            <div className="row">
                              <div className="col-md-2 mt-1">
                                Submitted Date From:{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.submittedDateFrom}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control myDatePicker"
                                  popperPlacement="bottom-end"
                                  onChange={this.handleSubmittedDateFrom}
                                />
                              </div>
                              <div className="col-md-2 mt-1">
                                Submitted Date To:{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.submittedDateTo}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handleSubmittedDateTo}
                                />
                              </div>
                            </div>

                            <div className="row mt-3">
                              <div className="col-md-2 mt-1">
                                Approved Date From:{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.fromDate}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handlefromDate}
                                />
                              </div>
                              <div className="col-md-2 mt-1">
                                Approved Date To:{" "}
                              </div>
                              <div className="col-lg-3">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={this.state.toDate}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control"
                                  popperPlacement="bottom-end"
                                  onChange={this.handletoDate}
                                />
                              </div>
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-2">Claim Status</div>
                              <div className="col-md-3">
                                <select
                                  className="form-control"
                                  onChange={this.handleChangeStatus.bind(this)}
                                >
                                  <option value="">All</option>
                                  <option value="D">Draft</option>
                                  <option value="P">Propose</option>
                                  <option value="A">Approve</option>
                                  <option value="I">Invalid</option>
                                  <option value="E">Revise</option>
                                  <option value="R">Reject</option>
                                </select>
                              </div>
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-3">
                                <button
                                  className="btn btn-primary btn-block"
                                  onClick={this.handleSearch.bind(this)}
                                >
                                  <i class="fas fa-search"></i> Search
                                </button>
                              </div>
                              <div className="col-md-3">
                                {/* { this.exportToExcel() } */}
                                <button
                                  className="btn btn-success btn-block"
                                  onClick={this.handleExport.bind(this)}
                                >
                                  <i className="fas fa-file-excel" /> Export To
                                  Excel
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default Summary;
